<template>
  <div class="home-page">
    <!-- Top Brand Banner -->
    <div class="top-brand-banner">
      <div class="brand-badge">B</div>
      <div class="brand-info">
        <div class="brand-title">BEZ CAPITAL</div>
        <div class="brand-subtitle">加密资产量化基金平台 / Crypto Asset Quantitative Fund</div>
      </div>
    </div>

    <!-- Hero Section -->
    <section class="hero">
      <div class="container">
        <div class="brand-logo">
          <h1 class="brand-name">
            <span class="brand-line-1">Be <span class="gradient-text">Eazy</span></span>
            <span class="brand-line-2">Invest <span class="gradient-text">Bez</span></span>
          </h1>
        </div>
        <p class="hero-description">我们专注于加密资产量化投资，结合多因子、趋势与统计套利策略， 通过严格的风险控制与稳健的执行，实现长期稳定的收益增长。</p>
        <button class="btn-primary" @click="goToLogin">
          <span>登录系统</span>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </section>

    <!-- Features Section -->
    <section class="features">
      <div class="container">
        <h3 class="section-title">核心功能</h3>
        <div class="features-grid">
          <div class="feature-card">
            <h4>实时净值追踪</h4>
            <p>每日更新投资池净值，自动计算客户收益变化</p>
          </div>
          <div class="feature-card">
            <h4>智能分发系统</h4>
            <p>金额自动分配，精准计算每位客户净值</p>
          </div>
          <div class="feature-card">
            <h4>可视化报表</h4>
            <p>直观的图表展示历史净值曲线和收益趋势</p>
          </div>
          <div class="feature-card">
            <h4>安全权限管理</h4>
            <p>管理员与客户分离，数据安全可靠</p>
          </div>
        </div>
      </div>
    </section>

    <!-- About Section -->
    <section class="about">
      <div class="container">
        <h3 class="section-title">关于我们</h3>
        <div class="about-content">
          <p>BEZ Capital 致力于为投资者提供专业、透明的资产管理服务。</p>
          <p>我们的净值管理系统帮助您实时追踪投资表现，让每一笔投资都清晰可见。</p>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="footer">
      <div class="container">
        <p>&copy; 2025 BEZ Capital. All rights reserved. 冀ICP备2023040968号  冀ICP备2023040968号-3</p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  methods: {
    goToLogin() {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.home-page {
  min-height: 100vh;
  background: var(--bg);
}

/* Top Brand Banner */
.top-brand-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  background: transparent;
  padding: 8px 16px;
  margin: 20px 0 0 20px;
  width: fit-content;
}

.brand-badge {
  width: 32px;
  height: 32px;
  background: #ffffff;
  color: #000000;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 18px;
}

.brand-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.brand-title {
  font-size: 14px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 1px;
}

.brand-subtitle {
  font-size: 10px;
  color: #999999;
  letter-spacing: 0.5px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Hero Section */
.hero {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 60px 0;
  position: relative;
  overflow: hidden;
}

.hero::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(91, 134, 255, 0.15) 0%, transparent 70%);
  animation: pulse-glow 4s ease-in-out infinite;
  pointer-events: none;
}

@keyframes pulse-glow {
  0%, 100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.5;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.2);
    opacity: 0.8;
  }
}

.brand-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 24px;
}

.brand-name {
  margin: 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 0;
  line-height: 1;
}

.brand-line-1,
.brand-line-2 {
  font-size: 72px;
  font-weight: 800;
  letter-spacing: 2px;
  background: linear-gradient(
    90deg,
    #ffffff 0%,
    #5b86ff 25%,
    #a855f7 50%,
    #5b86ff 75%,
    #ffffff 100%
  );
  background-size: 200% auto;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: gradient-shift 4s ease-in-out infinite, float-bounce 3s ease-in-out infinite;
  display: inline-block;
}

.brand-line-2 {
  animation-delay: 0.3s;
}

@keyframes gradient-shift {
  0% {
    background-position: 0% center;
  }
  50% {
    background-position: 100% center;
  }
  100% {
    background-position: 0% center;
  }
}

@keyframes float-bounce {
  0%, 100% {
    transform: translateY(0) scale(1);
  }
  25% {
    transform: translateY(-8px) scale(1.02);
  }
  50% {
    transform: translateY(0) scale(1);
  }
  75% {
    transform: translateY(-4px) scale(1.01);
  }
}

.hero-description {
  font-size: 16px;
  color: var(--muted);
  margin: 0 0 48px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.8;
  text-align: center;
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 56px;
  padding: 0 32px;
  background: var(--primary);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 16px rgba(91, 134, 255, 0.3);
}

.btn-primary:hover {
  background: var(--primary-press);
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(91, 134, 255, 0.4);
}

/* Features Section */
.features {
  padding: 100px 0;
  background: var(--card);
}

.section-title {
  font-size: 36px;
  font-weight: 700;
  text-align: center;
  margin: 0 0 64px;
  color: var(--text);
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 24px;
}

.feature-card {
  background: var(--card-2);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 32px 24px;
  text-align: center;
  transition: all 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-4px);
  border-color: var(--primary);
  box-shadow: 0 8px 24px rgba(91, 134, 255, 0.15);
}

.feature-card h4 {
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 12px;
  color: var(--text);
}

.feature-card p {
  font-size: 14px;
  color: var(--muted);
  margin: 0;
  line-height: 1.6;
}

/* About Section */
.about {
  padding: 100px 0;
}

.about-content {
  max-width: 800px;
  margin: 0 auto 48px;
  text-align: center;
}

.about-content p {
  font-size: 18px;
  color: var(--muted);
  margin: 0 0 16px;
  line-height: 1.8;
}

.team-info {
  max-width: 800px;
  margin: 0 auto;
  padding: 32px;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 16px;
  text-align: center;
}

.team-info h4 {
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 16px;
  color: var(--text);
}

.team-info p {
  font-size: 16px;
  color: var(--muted);
  margin: 0;
  line-height: 1.6;
}

/* Footer */
.footer {
  padding: 40px 0;
  border-top: 1px solid var(--border);
  text-align: center;
}

.footer p {
  margin: 0;
  color: var(--muted);
  font-size: 14px;
}

/* Responsive */
@media (max-width: 768px) {
  .top-brand-banner {
    margin: 10px 0 0 10px;
    padding: 6px 12px;
    gap: 8px;
  }

  .brand-badge {
    width: 28px;
    height: 28px;
    font-size: 16px;
  }

  .brand-title {
    font-size: 12px;
  }

  .brand-subtitle {
    font-size: 8px;
  }

  .brand-line-1,
  .brand-line-2 {
    font-size: 40px;
    letter-spacing: 1px;
  }

  .hero-description {
    font-size: 14px;
    line-height: 1.6;
    margin-bottom: 32px;
    padding: 0 16px;
  }

  .section-title {
    font-size: 28px;
  }

  .features-grid {
    grid-template-columns: 1fr;
  }

  .btn-primary {
    width: 100%;
    max-width: 300px;
    justify-content: center;
  }

  .btn-primary svg {
    display: none;
  }
}
</style>

